import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DeleteFilesButton from './buttons/DeleteFilesButton';
import DownloadButton from './buttons/DownloadButton';
import EditButton from './buttons/EditButton';
import NewFolderButton from './buttons/NewFolderButton';
import RenameButton from './buttons/RenameButton';
import UploadButton from './buttons/UploadButton';
import ViewLogsButton from './buttons/ViewLogsButton';

const FileActionToolbar = ({ actions, fileCount, loading, selectedFiles }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
      }}
    >
      <Typography fontSize="0.9em" fontWeight="600">
        {loading
          ? t('loading', { ns: 'fileBrowser' })
          : t('fileCount', { ns: 'fileBrowser', count: fileCount })}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        <NewFolderButton action={actions.create} loading={loading} />
        <UploadButton action={actions.upload} loading={loading} />
        <RenameButton
          action={actions.rename}
          loading={loading}
          selectedFiles={selectedFiles}
        />
        <EditButton
          action={actions.edit}
          loading={loading}
          selectedFiles={selectedFiles}
        />
        <ViewLogsButton
          loading={loading}
          onDownload={actions.download}
          onViewLogs={actions.logs}
          selectedFiles={selectedFiles}
        />
        <DownloadButton
          action={actions.download}
          loading={loading}
          selectedFiles={selectedFiles}
          onDownload={actions.download}
        />
        <DeleteFilesButton
          action={actions.delete}
          loading={loading}
          selectedFiles={selectedFiles}
        />
      </Box>
    </Box>
  );
};

FileActionToolbar.propTypes = {
  actions: PropTypes.object,
  fileCount: PropTypes.number,
  loading: PropTypes.bool,
  selectedFiles: PropTypes.array,
};

export default FileActionToolbar;
